class AgeGate extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.button = this.querySelector('.age-gate-button');
        this.button.addEventListener('click', this.onClick.bind(this));
        this.showModal();

        this.ageGateContainer = this.querySelector('.age-gate-container');
        this.ageGateContainer.addEventListener('wheel', this.onScroll.bind(this));
    }

    showModal() {
        if (localStorage.getItem('age-gate') === null) {
            this.isOpen = true;
            this.classList.add('active');
            document.body.style.overflow = 'hidden';
            setTimeout(() => {
                window.scrollHtml.stop();
            }, 1000);
        }
    }

    onClick() {
        localStorage.setItem('age-gate', true);
        this.classList.remove('active');
        document.body.style.overflow = 'auto';
        window.scrollHtml.start();
        this.isOpen = false;
    }

    onScroll(event) {
        if (!this.isOpen) return;
        const isScrollingUp = event.deltaY < 0;
        const isScrollingDown = event.deltaY > 0;
        if (this.ageGateContainer.scrollHeight > this.ageGateContainer.clientHeight) {
            event.preventDefault();
            isScrollingUp && (this.ageGateContainer.scrollTop -= 50);
            isScrollingDown && (this.ageGateContainer.scrollTop += 50);
        }
    }
}

customElements.define('age-gate', AgeGate);